<template>
  <div>
    <PageAllow controller="SubAccountAnalyses" action="mfShopSale" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRange
                type="datetime"
                v-model="datetimeRage"
                :label="$t('AlliancesSubAccounts.OrderCreated')"
                selectRange="sameMonth"
                @changedModel="datetimeRageChanged = $event"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">
                  {{
                    $store.state.showSearchPanel
                      ? "fa-angle-up"
                      : "fa-angle-down"
                  }}
                </v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="orderno"
                    v-model="options.orderno"
                    @text="ordernoKeyword = $event"
                    :label="$t('AlliancesSubAccounts.OrderCodeKeyword')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="branch_keyword"
                    v-model="options.branch_keyword"
                    @text="branckKeyword = $event"
                    :label="
                      $t('AlliancesSubAccounts.ShopKeyword', [
                        $consts.shopName(),
                      ])
                    "
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="orders"
            :options.sync="options"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="3">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money") }}
                    {{ priceTotal | formatMoney }}</span
                  >
                </td>
                <td></td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell"></div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("SubAccountAnalyses.TableHeaders.receiveMoney") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ priceTotal | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:item.orderno="{ item }">
              {{ item.orderno }}
            </template>
            <template v-slot:item.saletime="{ item }">
              {{ item.saletime | formatTime }}
            </template>
            <template v-slot:item.branchname="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.branchname }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.branchcode }}
              </span>
            </template>
            <template v-slot:item.collection="{ item }">
              {{ $t("Global.money") }}
              {{ item.collection | formatMoney }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                outlined
                color="info"
                class="px-2 me-2"
                @click.stop="
                  $router.push({
                    path: '/alliance-sub-accounts/detail',
                  });
                  setLocalStorage(item);
                "
              >
                <v-icon x-small class="pe-1">fa-align-left</v-icon>
                {{ $t("Opt.details") }}
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import consts from "@/consts";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Authorizations from "@/api/authorizations";
import AllianceSubAccounts from "@/api/alliance_sub_accounts";

const defaultOptions = {
  sale_time_from:
    new Date(new Date().getTime() - 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  sale_time_to:
    new Date(new Date().getTime() - 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 23:59:59",
  orderno: "",
  branch_keyword: "",
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherKeyword,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.alliancesSubAccounts", [
          consts.shopName(),
          consts.allianceName(),
        ]),
        disabled: true,
        href: "/alliance-sub-accounts",
      },
    ],

    headers: () => [
      {
        text: i18n.t("AlliancesSubAccounts.Fields.order_code"),
        align: "start",
        sortable: false,
        value: "orderno",
      },
      {
        text: i18n.t("AlliancesSubAccounts.Fields.created_time"),
        align: "start",
        sortable: false,
        value: "saletime",
      },
      {
        text: i18n.t("AlliancesSubAccounts.Fields.shop_name", [
          consts.shopName(),
        ]),
        align: "start",
        sortable: false,
        value: "branchname",
      },
      {
        text: i18n.t("AlliancesSubAccounts.Fields.price_count"),
        align: "end",
        sortable: false,
        value: "collection",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    ...mapState(["loading", "settings", "accessToken"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date(new Date().getTime() - 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 23:59:59",
    ],
    datetimeRageChanged: false,
    options: JSON.parse(JSON.stringify(defaultOptions)),
    ordernoKeyword: "",
    branckKeyword: "",
    shopcodeKeyword: "",
    orders: [],
    paging: {},
    priceTotal: 0,
  }),

  mounted() {
    if (!localStorage.getItem("midAccessToken")) {
      this.checkAccessToken();
    }
    //取session中的搜索条件
    this.$commonUtils.loadOptions("alliance-sub-account").then(
      function (data) {
        if (data.options) {
          this.options = data.options;
          if (
            typeof this.options.sale_time_from != "undefined" &&
            typeof this.options.sale_time_to != "undefined"
          )
            this.datetimeRage = [
              this.options.sale_time_from,
              this.options.sale_time_to,
            ];
        } else this.resetSearch();
      }.bind(this)
    );
  },

  methods: {
    checkAccessToken() {
      Authorizations.checkAccessTokenToMid({
        yywd_access_token: this.accessToken,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            localStorage.setItem("midAccessToken", response.data.access_token);
            this.getOrdersFromAPI();
          }
        }.bind(this)
      );
    },
    resetSearch() {
      this.datetimeRage = [
        new Date(new Date().getTime() - 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date(new Date().getTime() - 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.getOrdersFromAPI();
    },
    getOrdersFromAPI() {
      AllianceSubAccounts.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.orders = response.data.orders;
            this.priceTotal = response.data.price_total;
          } else if (response.data.error.code == "ERR099") {
            this.orders = [];
            this.options.page = 1;
          } else if (response.data.error.code == "ERR667") {
            this.checkAccessToken();
          }
        }.bind(this)
      );
    },
    setLocalStorage(order) {
      localStorage.setItem("alliance_sub_account_ticketcode", order.ticketcode);
      localStorage.setItem("alliance_sub_account_branchcode", order.branchcode);
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getOrdersFromAPI();
        sessionStorage.setItem(
          "alliance-sub-account-options",
          JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.sale_time_from =
            new Date(new Date().getTime() - 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.sale_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.sale_time_to =
            new Date(new Date().getTime() - 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 23:59:59";
        } else {
          this.options.sale_time_to = this.datetimeRage[1];
        }
      },
    },
  },
};
</script>